<!-- 外部リンクに関する情報を持っていたらリンクを表示 -->
<template>
  <div>
    <div
      v-for="(title, index) in titles.split(',')"
      :key="title"
      class="column-body"
    >
      <div class="buttons">
        <ExternalLinkButton :url="urls.split(',')[index]" :title="title" />
      </div>
    </div>
  </div>
</template>

<script>
import ExternalLinkButton from "@/views/Components/Atoms/ExternalLinkButton.vue";
export default {
  name: "MbExternalTitle",
  components: { ExternalLinkButton: ExternalLinkButton },
  props: {
    titles: {
      type: String,
      required: true,
    },
    urls: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.column-body {
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  color: #ffb206;
  margin-bottom: 10px;
}
</style>
